import axiosInstance from './AxiosInstance';

const API_URL = 'coursetype';

export const getCourseTypes = async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching course types', error);
        throw error;
    }
};

export const getCourseTypesList= async () => {
    try {
        const response = await axiosInstance.get(`${API_URL}/`);
        return response.data.map((f) => ({
            value: f.value,
            label: f.label,
        }));
    } catch (error) {
        console.error('Error fetching course types', error);
        return [];
    }
};

export const getCourseTypeById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching course type with id ${id}`, error);
        throw error;
    }
};

export const createCourseType = async (room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, room);
        return response.data;
    } catch (error) {
        console.error('Error creating course type', error);
        throw error;
    }
};

export const updateCourseType = async (id, room) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...room });
        return response.data;
    } catch (error) {
        console.error(`Error updating course type with id ${id}`, error);
        throw error;
    }
};

export const deleteCourseType = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting course type with id ${id}`, error);
        throw error;
    }
};
